<template>
  <div class="classContainer">
    <van-nav-bar
      title="课表进度表"
      left-text=""
      left-arrow
      :border="false"
      @click-left="onClickLeft"
    />
    <div class="classSchedule">
      <div class="teachingInfo">
        <van-cell-group inset>
          <van-cell title="课程名称：" :value="teachPlanDetailData.planName" />
          <van-cell title="专业：" :value="teachPlanDetailData.majorName" />
          <van-cell title="学期：" :value="teachPlanDetailData.semesterName" />
          <van-cell title="年级：" :value="teachPlanDetailData.classNames" />
          <van-cell title="总课时：" :value="teachPlanDetailData.theoryPeriod+teachPlanDetailData.experimentPeriod" />
          <van-cell title="教材：" :value="teachPlanDetailData.textbook" />
        </van-cell-group>
      </div>
      <div class="teachDes">
        <p class="title">上课说明</p>
        <p class="dsc">理论课地点：{{ teachPlanDetailData.theoryAddressName ? teachPlanDetailData.theoryAddressName : '无' }}</p>
        <p class="dsc">实验课地点：{{ teachPlanDetailData.experimentAddressName ? teachPlanDetailData.experimentAddressName : '无' }}</p>
        <p class="dsc">见习课地点：{{ teachPlanDetailData.internshipAddressName ? teachPlanDetailData.internshipAddressName : '无' }}</p>
      </div>
      <div class="teachDes">
        <p class="title">课程安排</p>
        <table>
          <thead>
          <tr>
            <th>周次</th>
            <th>日/星期</th>
            <th>课程内容</th>
            <th>节次</th>
            <th>教师</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in detailList">
            <td>{{ item.weekNum?item.weekNum:'-' }}</td>
            <td>{{ item.teachingDate }}{{item.teachWeekName }}</td>
            <td>{{item.lessonContent }}</td>
            <td>{{ item.periods }}</td>
            <td>{{ item.teacherName }}</td>
          </tr>
          </tbody>
        </table>
        <p class="sign">讲课负责教师<span class="value">____________________________</span></p>
        <p class="sign">教研室主任<span class="value">______________________________</span></p>
        <p class="sign right">签名（<span class="value">__________</span>月<span class="value">__________</span>日）</p>
        <p class="sign">实验见习负责教师<span class="value">_________________________</span></p>
        <p class="sign">教育科主任<span class="value">______________________________</span></p>
        <p class="sign right">审核（<span class="value">__________</span>月<span class="value">__________</span>日）</p>
        <p class="sign">医院<span class="value">___________________________________</span></p>
        <p class="sign right">审核（<span class="value">__________</span>月<span class="value">__________</span>日）</p>
        <p class="remark">
          1、此表务请逐项填写，讲课、实习内容必须具体实习如需放录象、电影、用显微镜以及其它条件,应在备注栏内注明,以便统筹安排。<br/><br/>
          2、填制一式三份在规定时间内交教育科审核后,一份交医学院，一份留教育科并向学生公布，一份留教研室。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { teachingPlanDetail } from '@/api/classSchedule'

export default {
  name: "teachProcessMain",
  data() {
    return {
      planId:'',
      teachPlanDetailData:{},
      detailList:[]
    }
  },
  methods: {
    onClickLeft(){
      this.$router.push('/classScheduleMain?semesterId='+this.$route.query.semesterId
        +'&majorId='+this.$route.query.majorId
        +'&classId='+this.$route.query.classId
        +'&weekday='+this.$route.query.weekday
        +'&semesterName='+this.$route.query.semesterName
        +'&majorName='+this.$route.query.majorName
        +'&gradeName='+this.$route.query.gradeName
        +'&yearWeekDateStr='+this.$route.query.yearWeekDateStr
        +'&weekName='+this.$route.query.weekName
      )
    },
    //获取教学计划详情
    async getTeachPlanDetail(){
      let res = await teachingPlanDetail(this.planId)
      this.teachPlanDetailData = res.data;
      this.detailList = res.data.detailList
    },
  },
  mounted() {
    this.planId = this.$route.query.planId

    this.getTeachPlanDetail()
  },
}
</script>
<style scoped lang="scss">
::v-deep .van-nav-bar .van-icon{
  color: #2F2F46
}
::v-deep .van-cell-group--inset{
  margin: 0;
  padding-top: 15px;
  border-radius: 12px;
}
::v-deep .van-cell{
  font-weight: 400;
  font-size: 14px;
  color: #2F2F46;
}
::v-deep .van-cell__value{
  color: #7A7C8B;
}
.classContainer {
  .classSchedule {
    height: calc(100vh - 46px);
    background: #f5f5f5;
    padding: 12px 16px;
    overflow-y: auto;
  }
  .teachDes{
    margin-top: 12px;
    padding: 19px 13px 15px 16px;
    background: #FFFFFF;
    border-radius: 12px;
    .title{
      font-weight: 600;
      font-size: 17px;
      color: #2F2F46;
      margin-bottom: 10px;
    }
    .dsc{
      margin-top: 10px;
      font-size: 14px;
      color: #7A7C8B;
      line-height: 20px;
    }
    table {
      width: 100%; /* 表格宽度 */
      border-collapse: collapse; /* 合并边框 */
      border: 1px solid #EEEEEE; /* 外边框 */
      font-family: Arial, sans-serif;
      table-layout: fixed
    }

    /* 表头样式 */
    th {
      border: 1px solid #EEEEEE; /* 内边框 */
      padding: 10px; /* 内边距 */
      text-align: center; /* 文字对齐 */
      font-weight: 400;
      font-size: 14px;
      color: #2F2F46;

    }

    /* 表格单元格样式 */
    td {
      //width: 24%;
      border: 1px solid #EEEEEE; /* 内边框 */
      padding: 8px; /* 内边距 */
      text-align: center; /* 文字对齐 */
      font-weight: 400;
      font-size: 12px;
      color: #2F2F46;
      word-break: break-word;
    }
    .sign{
      margin-top: 15px;
      font-weight: 400;
      font-size: 14px;
      color: #2F2F46;
      .value{
        color: #eeeeee;
        margin-left: 5px;
      }
    }
    .right{
      text-align: right;
    }
    .remark{
      margin-top: 25px;
      font-size: 14px;
      color: #8F91A1;
      line-height: 20px;
    }
  }
}
</style>
